import styled from 'styled-components';


const CategoryIndexStyle = styled.div`
    background-color: #ffffff;
    margin: 10px;

    a {
        text-decoration: none;
    }

    .header {
        // margin: 0 0 0 10px;
        // padding: 20px 0 0 25px;
        font-size: 24px;
        text-transform: capitalize;
        padding: 17px 10px 8px 10px;
        margin: 0;

    }

    .articlesContainer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        // padding: 0 25px 10px 25px;
        padding: 7px 10px 10px 10px;
    }

    .individualArticle:first-of-type {
        margin-top: 0;
        // border: 1px solid red;
    }
    .individualArticle {
        box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.09);
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        width: 100%;
        margin: 10px 0;

        .imageContainer {
            width: 252px;
            height: 180px;
        }

        .text {
            // width: 100%;
            box-sizing: border-box;
            width: 100%;
            height: auto;
            padding: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        .title {
            width: 100%;
            // height: 84px;
            font-family: Helvetica Neue;
            font-size: 23px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.22;
            letter-spacing: normal;
            color: #000000;
            margin: 0 0 12px 0;
            text-transform: capitalize;
        }

        .dateAndAuthor {
            height: 16px;
            width: 100%;
            font-size: 14px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #6f6d6d;
            margin: 13px 0 13px 0;
        }

        .description {
            // min-width: 318px;
            min-height: 48px;
            font-family: Helvetica Neue;
            font-size: 19px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.26;
            letter-spacing: normal;
            color: #818181;
        }

        .articleType {
            display: flex;
            justify-content: center;
            align-content: center;
            flex-direction: column;
            width: 59px;
            height: 22px;
            background-color: $news-type;
            border-radius: 2px;
            color: $white;
            font-size: 13px;
            text-transform: uppercase;
            text-align: center;
        }
    }

    .nextAndBackContainer {
        width: 100%;
        display: flex;
        justify-content: center;
    }


    @media (min-width: 750px) {

        .header {
            padding: 20px 25px 0 25px;
        }

        .articlesContainer {
            padding: 20px 25px 10px 25px;
        }

        .individualArticle {
            flex-direction: row;
            justify-content: space-between;
            height: 180px;
            // margin-bottom: 5px;

            .description {
                // min-height: 48px;
                min-height: auto;
            }

            .text {
                // padding: 16px;
                width: 100%;
            }

            .dateAndAuthor {

                margin-bottom: 0;
            }
        }


    }

    `
export default CategoryIndexStyle
